
import './App.css';
import React, { useState, useEffect } from 'react';
import "leaflet/dist/leaflet.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import Footer from './components/Footer';
import AboutSection from './components/AboutSection';
import TermsConditions from './components/TermsConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import Service from './pages/Service';
import OurFleets from './pages/OurFleets';
import Packages from './pages/Packages';
import ContactSection from './pages/ContactSection';
import Enquiry from './pages/Enquiry';
import Career from './components/Career';
import Gallery from './pages/Gallery';
import Booking from './pages/Booking';
import OurNetwork from './pages/OurNetwork';
import Tempotravelleronrentinpune from './pages/Tempo Traveller On Rent in Pune';
import ScrollToTop from './components/ScrollToTop';
import Punetomahabaleshwartempotraveller from './pages/Pune to Mahabaleshwar Tempo Traveller';
import Punetooutstationtempotraveller from './pages/Pune to Outstation Tempo Traveller';
import Minibusonrentinpune from './pages/Mini Bus On Rent in Pune';
import Onefoudrseaterbusonrent from './pages/14 17 20 25 Seater Bus on Rent in Pune';
import Outstationminibusonrentpune from './pages/Outstation Mini Bus on Rent Pune';
import Onefourtempotravelleronrentinpune from './pages/14 Seater Tempo Traveller on Rent in Pune';
import Onesevenbusonrentinpune from './pages/17 Seater Bus on Rent in Pune';
import Punetoshirditempotraveller from './pages/Pune to Shirdi Tempo Traveller';
import Twozerobusonrentinpune from './pages/20 Seater Bus on Rent in Pune';
import Twofivetempotravelleronrent from './pages/25 Seater Tempo Traveller on Rent in Pune';
import Tempotravelleronrentinpimprichichwad from './pages/Tempo Traveller on Rent in Pimpri Chinchwad';
import Threetwoseaterbusrentinpune from './pages/32 Seater Bus Rent in Pune';
import Threefiveseaterbusonrentinpune from './pages/35 Seater Bus on Rent in Pune';
import Fourfiveseaterbusonrentinpune from './pages/45 Seater Bus on Rent in Pune';
import Fivezeroseaterbusonrentinpune from './pages/50 Seater Bus On Rent in Pune';
import Nonacbusrentalserviceinpune from './pages/Non AC Bus Rental Service in Pune';
import Luxurybusrentalinpune from './pages/Luxury Bus Rental in Pune';
import Luxuryforceurbaniaonrentinpune from './pages/Luxury Force Urbania On Rent in Pune';
import Forceurbanialuxuryminibusonrent from './pages/Force Urbania Luxury Mini Bus On Rent';
import Travelagentsinpuneforminibushire from './pages/Travel Agents in Pune for Mini Bus Hire';
import Tempotravellerhireinpune from './pages/Tempo Traveller Hire in Pune';
import Forceurbaniaonrentinashtavinayakkdarshank from './pages/Force Urbania On Rent for Ashtavinayak Darshan';
import Punetomahabaleshwwarurbaniaonrent from './pages/Pune to Mahabaleshwar Urbania On Rent';
import Punetobhimashankarminibushire from './pages/Pune to Bhimashankar Mini Bus Hire in Pune';
import Bushireforschooltripsinpune from './pages/Bus Hire for School Trips in Pune';
import Punelocalbusonrent from './pages/Pune Local Bus on Rent';
import Busonrentinkharadipune from './pages/Bus On Rent in Kharadi Pune';
import Busonrentinhinnjewadi from './pages/Bus on Rent in Hinjewadi';
import Tempotravellerhireinhinjewadipune from './pages/Tempo Traveller hire in Hinjewadi Pune';
import Tempotravelleronrentinkharadipune from './pages/Tempo Traveller on Rent in Kharadi Pune';
import Tempotravellerhireinwakadpune from './pages/Tempo Traveller hire in Wakad Pune';
import Tempotravelleronrentinbanerpune from './pages/Tempo Traveller on Rent in Baner Pune';
import Tempotravellerhireinhadapsar from './pages/Tempo Traveller hire in Hadapsar Pune';
import Tempotravellerhireinvimannagarpune from './pages/Tempo Traveller hire in Viman Nagar Pune';
import Tempotravelleronrentinkothrudpune from './pages/Tempo Traveller on Rent in Kothrud Pune';
import Tempotravellerhireininwagholipune from './pages/Tempo Traveller hire in Wagholi Pune';
import Tempotravelleronrentinaundhpune from './pages/Tempo Traveller on Rent in Aundh Pune';
import Tempotravellerhireinmagarpattapune from './pages/Tempo Traveller hire in Magarpatta Pune';
import Tempotravelleronrentinbavdhanpune from './pages/Tempo Traveller on Rent in Bavdhan Pune';
import Tempotravellerhireinpimplesaudagar from './pages/Tempo Traveller hire in Pimple Saudagar Pune';
import Tempotravelleronrentinchichwadpune from './pages/Tempo Traveller on Rent in Chinchwad Pune';
import Weddingminibusrentalinpune from './pages/Wedding Mini Bus Rental in Pune';
import Punetoshirdiminibus from './pages/Pune to Shirdi Mini Bus';
import Punetomahabaleshwarminibus from './pages/Pune to Mahabaleshwar Mini Bus';
import Minibusonrentinhinjewadi from './pages/Mini Bus On Rent in Hinjewadi';
import Minibusonrentinwakad from './pages/Mini Bus On Rent in Wakad';
import Minibusonrentinbaner from './pages/Mini Bus On Rent in Baner';
import Minibusonrentinkharadi from './pages/Mini Bus On Rent in Kharadi';
import Minibusonrentinhadapsar from './pages/Mini Bus On Rent in Hadapsar';
import Minibusonrentinpimprichichwad from './pages/Mini Bus On Rent in Pimpri Chinchwad';
import Minibusonrentinvimannagar from './pages/Mini Bus On Rent in Viman Nagar';
import Minibusonrentinkkothrud from './pages/Mini Bus On Rent in Kothrud';
import Minibusonrentinwagholi from './pages/Mini Bus On Rent in Wagholi';
import Minibusonrentinaundh from './pages/Mini Bus On Rent in Aundh';
import Minibusonrentinbavdhan from './pages/Mini Bus On Rent in Bavdhan';
import { WiMoonAltWaningGibbous1 } from 'react-icons/wi';
import Minibusonrentinmagarpatta from './pages/Mini Bus On Rent in Magarpatta';
import Minibusonrentinpimplesaudaugar from './pages/Mini Bus On Rent in Pimple Saudagar';
import Minibusinchinchwadpune from './pages/Mini Bus in Chinchwad Pune';
import Minibusonrentinnigdipune from './pages/Mini Bus On Rent in Nigdi Pune';
import Minibusonrentinravet from './pages/Mini Bus On Rent in Ravet Pune';
import Minibusonrentintalegaonpune from './pages/Mini Bus On Rent in Talegaon Pune';
import Minibusonrentinbhosaripune from './pages/Mini Bus On Rent in Bhosari Pune';
import Minibusonrentinmoshi from './pages/Mini Bus On Rent in Moshi';
import Minibusonrentindhankawadipune from './pages/Mini Bus On Rent in Dhankawadi Pune';
import Minibushireinkrvenagarpune from './pages/Mini Bus Hire in Karve Nagar Pune';
import Minibushireinsinhgadroad from './pages/Mini Bus Hire in Sinhagad Road Pune';
import Minibushireinnarhepune from './pages/Mini Bus Hire in Narhe Pune';
import Minibusonrentincamp from './pages/Mini Bus On Rent in Camp Pune';
import Onethreeseateractempotraveller from './pages/13 Seater AC Tempo Traveller on Rent Pune';
import Oneseventempotravelleronrent from './pages/17 Seater Tempo Traveller On Rent in Pune';
import Twozeroseatertempotraveller from './pages/20 Seater Tempo Traveller On Rent in Pune';
import Twosixseatertempotraveller from './pages/26 Seater Tempo Traveller On Rent in Pune';
import Threetwoseatertempotraveller from './pages/32 seater tempo traveller on rent Pune';
import Threeseaterbusrental from './pages/35-Seater Bus Rental in Pune';
import Manyseaterbuses from './pages/32, 35, 40, 45, and 50 Seater Buses on Rent in Pune';
import Multiseaterbuses from './pages/14, 17, 20, and 25-Seater Bus Rental in Pune';
import Tempotravellerhireforeventspune from './pages/Tempo Traveller Hire for Event Pune';
import Weddingbusrentalserviceinpune from './pages/Wedding Bus Rental Services in Pune';
import Schoolpicnicbusrentalserviceinpune from './pages/School Picnic Bus Rental Services in Pune';
import Urbaniaonrentinpune from './pages/Urbania On Rent in Pune';
import Urbaniaonrentinpimprichichwad from './pages/Urbania on Rent in Pimpri Chinchwad';
import Urbaniahireforcorporateevets from './pages/Urbania Hire for Corporate Events in Pune';
import Onesevenurbaniaonrent from './pages/17 Seater Urbania on Rent in Pune';
import Onefourseaterurbania from './pages/14 Seater Urbania on Rent in Pune';
import Urbaniaonrentinkharadi from './pages/Urbania on Rent in Kharadi';
import Urbaniaonrentinhadapsar from './pages/Urbania on Rent in Hadapsar';
import Urbaniaonrentinkothrud from './pages/Urbania on Rent in Kothrud';
import Urbaniaonrentinbibwewadi from './pages/Urbania On Rent in Bibwewadi';
import Urbaniaonrentinkoregaonpark from './pages/Urbania on Rent in Koregaon Park';
import Punetoujjaintempotraveller from './pages/Pune to Ujjain Tempo Traveller on Rent';
import Punetoashtavinayakdarshan from './pages/Pune to Ashtavinayak Darshan Tempo Traveller';
import ContactButtons from './components/ContactButtons';

function App() {
  return (
    <Router>
<Header/>
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/career" element={<Career />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<Service />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/our-network" element={<OurNetwork />} />
        <Route path="/our-fleet" element={<OurFleets />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/contact-us" element={<ContactSection />} />
        <Route path="/enquiry" element={<Enquiry />} />

<Route path="/Tempo-Traveller-On-Rent-in-Pune" element={<Tempotravelleronrentinpune />} />
<Route path="/Pune-to-Mahabaleshwar-Tempo-Traveller" element={<Punetomahabaleshwartempotraveller />} />
<Route path="/Pune-to-Outstation-Tempo-Traveller" element={<Punetooutstationtempotraveller />} />
<Route path="/Mini-Bus-On-Rent-in-Pune" element={<Minibusonrentinpune />} />
<Route path="/Outstation-Mini-Bus-on-Rent-Pune" element={<Outstationminibusonrentpune />} />
<Route path="/14-Seater-Tempo-Traveller-on-Rent-in-Pune" element={<Onefourtempotravelleronrentinpune />} />
<Route path="/17-Seater-Bus-on-Rent-in-Pune" element={<Onesevenbusonrentinpune />} />
<Route path="/Pune-to-Shirdi-Tempo-Traveller" element={<Punetoshirditempotraveller />} />
<Route path="/20-Seater-Bus-on-Rent-in-Pune" element={<Twozerobusonrentinpune />} />
<Route path="/25-Seater-Tempo-Traveller-on-Rent-in-Pune" element={<Twofivetempotravelleronrent />} />
<Route path="/Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" element={<Tempotravelleronrentinpimprichichwad />} />
<Route path="/32-Seater-Bus-Rent-in-Pune" element={<Threetwoseaterbusrentinpune />} />
<Route path="/35-Seater-Bus-on-Rent-in-Pune" element={<Threefiveseaterbusonrentinpune />} />
<Route path="/45-Seater-Bus-on-Rent-in-Pune" element={<Fourfiveseaterbusonrentinpune />} />
<Route path="/50-Seater-Bus-On-Rent-in-Pune" element={<Fivezeroseaterbusonrentinpune />} />
<Route path="/Non-AC-Bus-Rental-Service-in-Pune" element={<Nonacbusrentalserviceinpune />} />
<Route path="/Luxury-Bus-Rental-in-Pune" element={<Luxurybusrentalinpune />} />
<Route path="/Luxury-Force-Urbania-On-Rent-in-Pune" element={<Luxuryforceurbaniaonrentinpune />} />
<Route path="/Force-Urbania-Luxury-Mini-Bus-On-Rent" element={<Forceurbanialuxuryminibusonrent />} />
{/* <Route path="/Mini-Bus-On-Rent-in-Pune-2" element={<MiniBusOnRentPuneTwo />} /> */}
<Route path="/14-17-20-25-Seater-Bus-on-Rent-in-Pune" element={<Onefoudrseaterbusonrent />} />
<Route path="/Travel-Agents-in-Pune-for-Mini-Bus-Hire" element={<Travelagentsinpuneforminibushire />} />
<Route path="/Tempo-Traveller-Hire-in-Pune" element={<Tempotravellerhireinpune />} />
<Route path="/Force-Urbania-On-Rent-for-Ashtavinayak-Darshan" element={<Forceurbaniaonrentinashtavinayakkdarshank />} />
<Route path="/Pune-to-Mahabaleshwar-Urbania-On-Rent" element={<Punetomahabaleshwwarurbaniaonrent />} />
<Route path="/Pune-to-Bhimashankar-Mini-Bus-Hire-in-Pune" element={<Punetobhimashankarminibushire />} />
<Route path="/Bus-Hire-for-School-Trips-in-Pune" element={<Bushireforschooltripsinpune />} />
<Route path="/Pune-Local-Bus-on-Rent" element={<Punelocalbusonrent />} />
<Route path="/Bus-On-Rent-in-Kharadi-Pune" element={<Busonrentinkharadipune />} />
<Route path="/Bus-on-Rent-in-Hinjewadi" element={<Busonrentinhinnjewadi />} />
<Route path="/Tempo-Traveller-hire-in-Hinjewadi-Pune" element={<Tempotravellerhireinhinjewadipune />} />
<Route path="/Tempo-Traveller-on-Rent-in-Kharadi-Pune" element={<Tempotravelleronrentinkharadipune />} />

<Route path="/Tempo-Traveller-hire-in-Wakad-Pune" element={<Tempotravellerhireinwakadpune />} />
<Route path="/Tempo-Traveller-on-Rent-in-Baner-Pune" element={<Tempotravelleronrentinbanerpune />} />
<Route path="/Tempo-Traveller-hire-in-Hadapsar-Pune" element={<Tempotravellerhireinhadapsar />} />
<Route path="/Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad-2" element={<Tempotravellerhireinvimannagarpune />} />
<Route path="/Tempo-Traveller-hire-in-Viman-Nagar-Pune" element={<Tempotravellerhireinvimannagarpune />} />
<Route path="/Tempo-Traveller-on-Rent-in-Kothrud-Pune" element={<Tempotravelleronrentinkothrudpune />} />
<Route path="/Tempo-Traveller-hire-in-Wagholi-Pune" element={<Tempotravellerhireininwagholipune />} />
<Route path="/Tempo-Traveller-on-Rent-in-Aundh-Pune" element={<Tempotravelleronrentinaundhpune />} />
<Route path="/Tempo-Traveller-hire-in-Magarpatta-Pune" element={<Tempotravellerhireinmagarpattapune />} />
<Route path="/Tempo-Traveller-on-Rent-in-Bavdhan-Pune" element={<Tempotravelleronrentinbavdhanpune />} />
<Route path="/Tempo-Traveller-hire-in-Pimple-Saudagar-Pune" element={<Tempotravellerhireinpimplesaudagar />} />
<Route path="/Tempo-Traveller-on-Rent-in-Chinchwad-Pune" element={<Tempotravelleronrentinchichwadpune />} />
<Route path="/Wedding-Mini-Bus-Rental-in-Pune" element={<Weddingminibusrentalinpune />} />
<Route path="/Pune-to-Shirdi-Mini-Bus" element={<Punetoshirdiminibus />} />
<Route path="/Pune-to-Mahabaleshwar-Mini-Bus" element={<Punetomahabaleshwarminibus />} />
<Route path="/Mini-Bus-On-Rent-in-Hinjewadi" element={<Minibusonrentinhinjewadi />} />
<Route path="/Mini-Bus-On-Rent-in-Wakad" element={<Minibusonrentinwakad />} />
<Route path="/Mini-Bus-On-Rent-in-Baner" element={<Minibusonrentinbaner />} />
<Route path="/Mini-Bus-On-Rent-in-Kharadi" element={<Minibusonrentinkharadi />} />
<Route path="/Mini-Bus-On-Rent-in-Hadapsar" element={<Minibusonrentinhadapsar />} />
<Route path="/Mini-Bus-On-Rent-in-Pimpri-Chinchwad" element={<Minibusonrentinpimprichichwad />} />
<Route path="/Mini-Bus-On-Rent-in-Viman-Nagar" element={<Minibusonrentinvimannagar />} />
<Route path="/Mini-Bus-On-Rent-in-Kothrud" element={<Minibusonrentinkkothrud />} />
<Route path="/Mini-Bus-On-Rent-in-Wagholi" element={<Minibusonrentinwagholi />} />
<Route path="/Mini-Bus-On-Rent-in-Aundh" element={<Minibusonrentinaundh />} />
<Route path="/Mini-Bus-On-Rent-in-Bavdhan" element={<Minibusonrentinbavdhan />} />
<Route path="/Mini-Bus-On-Rent-in-Magarpatta" element={<Minibusonrentinmagarpatta />} />
<Route path="/Mini-Bus-On-Rent-in-Pimple-Saudagar" element={<Minibusonrentinpimplesaudaugar />} />
<Route path="/Mini-Bus-On-Rent-in-Chinchwad-Pune" element={<Minibusinchinchwadpune />} />
<Route path="/Mini-Bus-On-Rent-in-Nigdi-Pune" element={<Minibusonrentinnigdipune />} />
<Route path="/Mini-Bus-On-Rent-in-Ravet-Pune" element={<Minibusonrentinravet />} />
<Route path="/Mini-Bus-On-Rent-in-Talegaon-Pune" element={<Minibusonrentintalegaonpune />} />
<Route path="/Mini-Bus-On-Rent-in-Bhosari-Pune" element={<Minibusonrentinbhosaripune />} />
<Route path="/Mini-Bus-On-Rent-in-Moshi" element={<Minibusonrentinmoshi />} />
<Route path="/Mini-Bus-On-Rent-in-Dhankawadi-Pune" element={<Minibusonrentindhankawadipune />} />
<Route path="/Mini-Bus-Hire-in-Karve-Nagar-Pune" element={<Minibushireinkrvenagarpune />} />
<Route path="/Mini-Bus-Hire-in-Sinhagad-Road-Pune" element={<Minibushireinsinhgadroad />} />
<Route path="/Mini-Bus-Hire-in-Narhe-Pune" element={<Minibushireinnarhepune />} />
<Route path="/Mini-Bus-On-Rent-in-Camp-Pune" element={<Minibusonrentincamp />} />
<Route path="/13-Seater-AC-Tempo-Traveller-on-Rent-in-Pune" element={<Onethreeseateractempotraveller />} />
<Route path="/17-Seater-Tempo-Traveller-on-Rent-in-Pune" element={<Oneseventempotravelleronrent />} />
<Route path="/20-Seater-Tempo-Traveller-on-Rent-in-Pune" element={<Twozeroseatertempotraveller />} />
<Route path="/26-Seater-Tempo-Traveller-on-Rent-in-Pune" element={<Twosixseatertempotraveller />} />
<Route path="/32-Seater-Tempo-Traveller-on-Rent-in-Pune" element={<Threetwoseatertempotraveller />} />
<Route path="/35-Seater-Bus-Rental-in-Pune" element={<Threeseaterbusrental />} />
<Route path="/Multi-Seater-Bus-Rentals-in-Pune" element={<Manyseaterbuses />} />
<Route path="/Bus-Rental-14-17-20-25-Seater-in-Pune" element={<Multiseaterbuses />} />
<Route path="/Tempo-Traveller-Hire-for-Event-Pune" element={<Tempotravellerhireforeventspune />} />
<Route path="/Wedding-Bus-Rental-Services-in-Pune" element={<Weddingbusrentalserviceinpune />} />
<Route path="/School-Picnic-Bus-Rental-Services-in-Pune" element={<Schoolpicnicbusrentalserviceinpune />} />
<Route path="/Urbania-On-Rent-in-Pune" element={<Urbaniaonrentinpune />} />
<Route path="/Urbania-On-Rent-in-Pimpri-Chinchwad" element={<Urbaniaonrentinpimprichichwad />} />
<Route path="/Urbania-Hire-for-Corporate-Events-in-Pune" element={<Urbaniahireforcorporateevets />} />
<Route path="/17-Seater-Urbania-on-Rent-in-Pune" element={<Onesevenurbaniaonrent />} />
<Route path="/14-Seater-Urbania-on-Rent-in-Pune" element={<Onefourseaterurbania />} />
<Route path="/Urbania-on-Rent-in-Kharadi" element={<Urbaniaonrentinkharadi />} />
<Route path="/Urbania-on-Rent-in-Hadapsar" element={<Urbaniaonrentinhadapsar />} />
<Route path="/Urbania-on-Rent-in-Kothrud" element={<Urbaniaonrentinkothrud />} />
<Route path="/Urbania-On-Rent-in-Bibwewadi" element={<Urbaniaonrentinbibwewadi />} />
<Route path="/Urbania-on-Rent-in-Koregaon-Park" element={<Urbaniaonrentinkoregaonpark />} />
<Route path="/Pune-to-Ujjain-Tempo-Traveller-on-Rent" element={<Punetoujjaintempotraveller />} />
<Route path="/Pune-to-Ashtavinayak-Darshan-Tempo-Traveller" element={<Punetoashtavinayakdarshan />} />
       
     </Routes>


<Footer/>
    </Router>
  );
}

export default App;
